const realisations = document.querySelectorAll('.block-touteslesrealisations');

if (realisations.length > 0) {
  for (let i = 0; i < realisations.length; i++) {
    const realisationsGrid = realisations[i];
    const filters = realisationsGrid.querySelectorAll(
      '.block-touteslesrealisations-filtres .button'
    );
    const toutesLesRealisations = realisationsGrid.querySelectorAll(
      '.block-touteslesrealisations-list .realisation'
    );

    for (let j = 0; j < filters.length; j++) {
      filters[j].addEventListener(
        'click',
        e => {
          resetActiveButton(filters);
          resetGrid(toutesLesRealisations);
          setActiveButton(e);
          filterGrid(e, toutesLesRealisations);
        },
        false
      );
    }
  }
}

function resetActiveButton(buttons) {
  for (let k = 0; k < buttons.length; k++) {
    buttons[k].classList.remove('is-active');
  }
}

function resetGrid(realisations) {
  for (let m = 0; m < realisations.length; m++) {
    realisations[m].classList.remove('is-hidden');
  }
}

function setActiveButton(e) {
  const target = e.target;
  target.classList.add('is-active');
}

function filterGrid(e, realisations) {
  const target = e.target;
  const targetCategory = target.dataset.category;

  for (let l = 0; l < realisations.length; l++) {
    const categories = realisations[l].dataset.cateogories;
    if (!categories.includes(targetCategory)) {
      realisations[l].classList.add('is-hidden');
    }
  }
}
